<template>
  <div class="app-shell" :class="{ 'nav-open': mobileNav }">
    <div class="site-chrome" :class="{ 'with-topbar': hasTopBar }">
      <div class="global-topbar" v-if="hasTopBar">
        <div class="bar-inner">
          <div class="socials" v-if="anySocial">
            <a
              v-if="settings.facebook"
              :href="settings.facebook"
              target="_blank"
              :aria-label="$t('social.facebook')"
              ><svg viewBox="0 0 24 24">
                <path
                  d="M13.5 22v-8.25H16l.375-3h-2.875V8.75c0-.87.286-1.5 1.55-1.5H16.5V4.6c-.268-.036-1.188-.1-2.262-.1-2.24 0-3.738 1.37-3.738 3.882V10.75H8v3h2.5V22h3z"
                  fill="currentColor"
                /></svg
            ></a>
            <a
              v-if="settings.youtube"
              :href="settings.youtube"
              target="_blank"
              :aria-label="$t('social.youtube')"
              ><svg viewBox="0 0 24 24">
                <path
                  fill="currentColor"
                  d="M23 7.1s-.2-1.6-.8-2.3c-.7-.8-1.5-.8-1.9-.9C17.9 3.6 12 3.6 12 3.6h0s-5.9 0-8.3.3c-.4 0-1.2.1-1.9.9C1.2 5.5 1 7.1 1 7.1S.8 8.9.8 10.7v1.6c0 1.8.2 3.6.2 3.6s.2 1.6.8 2.3c.7.8 1.7.8 2.1.9 1.5.1 6.1.3 8.1.3 0 0 5.9 0 8.3-.3.4-.1 1.2-.1 1.9-.9.6-.7.8-2.3.8-2.3s.2-1.8.2-3.6v-1.6c0-1.8-.2-3.6-.2-3.6ZM9.9 14.6V8.4l5.4 3.1-5.4 3.1Z"
                /></svg
            ></a>
            <a
              v-if="settings.instagram"
              :href="settings.instagram"
              target="_blank"
              :aria-label="$t('social.instagram')"
              ><svg viewBox="0 0 24 24">
                <path
                  fill="currentColor"
                  d="M7 2C4.2 2 2 4.2 2 7v10c0 2.8 2.2 5 5 5h10c2.8 0 5-2.2 5-5V7c0-2.8-2.2-5-5-5H7zm10 2c1.7 0 3 1.3 3 3v10c0 1.7-1.3 3-3 3H7c-1.7 0-3-1.3-3-3V7c0-1.7 1.3-3 3-3h10zm-5 2.5A5.5 5.5 0 006.5 12 5.5 5.5 0 0012 17.5 5.5 5.5 0 0017.5 12 5.5 5.5 0 0012 6.5zm0 2A3.5 3.5 0 0115.5 12 3.5 3.5 0 0112 15.5 3.5 3.5 0 018.5 12 3.5 3.5 0 0112 8.5zM17.8 6a1.3 1.3 0 100 2.6 1.3 1.3 0 000-2.6z"
                /></svg
            ></a>
            <a
              v-if="settings.soundcloud"
              :href="settings.soundcloud"
              target="_blank"
              :aria-label="$t('social.soundcloud')"
              ><svg viewBox="0 0 24 24">
                <path
                  fill="currentColor"
                  d="M17.6 10.2c-.3 0-.6 0-.9.1a4.6 4.6 0 00-9.1.9v.2a2.55 2.55 0 00.4 5.1h9.6a3.4 3.4 0 00.1-6.8z"
                /></svg
            ></a>
            <a
              v-if="settings.spotify"
              :href="settings.spotify"
              target="_blank"
              :aria-label="$t('social.spotify')"
              ><svg viewBox="0 0 24 24">
                <path
                  fill="currentColor"
                  d="M12 2.1A9.9 9.9 0 1 0 22 12 9.9 9.9 0 0 0 12 2.1Zm4.55 14.37c-.18.29-.56.38-.85.2-2.34-1.42-5.28-1.74-8.75-.96a.63.63 0 0 1-.3-1.23c3.78-.86 7.02-.5 9.62 1.1.29.18.38.56.2.85Zm1.17-2.62c-.22.35-.69.46-1.04.24-2.67-1.64-6.74-2.12-9.9-1.17a.74.74 0 1 1-.42-1.42c3.6-1.06 8.07-.54 11.14 1.32.35.21.46.68.23 1.03Zm.1-2.78c-3.18-1.89-8.45-2.06-11.5-1.14a.84.84 0 0 1-.47-1.6c3.5-1.03 9.32-.83 12.98 1.36a.85.85 0 0 1-.87 1.46Z"
                /></svg
            ></a>
            <a
              v-if="settings.apple"
              :href="settings.apple"
              target="_blank"
              :aria-label="$t('social.apple')"
              class="apple-link"
              ><svg viewBox="0 0 24 24" class="apple-icon" aria-hidden="true">
                <path
                  fill="currentColor"
                  d="M12 3v10.55c-.59-.34-1.27-.55-2-.55-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4V7h4V3h-6z"
                /></svg
            ></a>
          </div>
          <div class="contacts">
            <a
              v-if="settings.phone"
              :href="'tel:' + settings.phone.replace(/[^+\\d]/g, '')"
              class="contact-link"
              :aria-label="$t('common.callPhone')"
              >📞 {{ settings.phone }}</a
            >
            <a
              v-if="settings.email1"
              :href="'mailto:' + settings.email1"
              class="contact-link"
              :aria-label="$t('common.emailPrimaryLabel')"
              >✉ {{ settings.email1 }}</a
            >
            <a
              v-if="settings.email2"
              :href="'mailto:' + settings.email2"
              class="contact-link"
              :aria-label="$t('common.emailSecondaryLabel')"
              >✉ {{ settings.email2 }}</a
            >
          </div>
        </div>
      </div>
      <header class="site-header">
        <div class="inner">
          <router-link
            class="logo"
            :class="{ 'has-logo-image': settings.header_image }"
            to="/"
            :aria-label="$t('brand.name')"
          >
            <img
              v-if="settings.header_image"
              class="logo-image"
              :src="settings.header_image"
              :alt="$t('brand.name')"
            />
            <span class="logo-text">{{ $t('brand.name') }}</span>
          </router-link>
          <button
            class="nav-toggle"
            @click="mobileNav = !mobileNav"
            :aria-label="$t('common.menu')"
            :aria-expanded="mobileNav"
          >
            ☰
          </button>
          <nav class="main-nav" @click="mobileNav = false">
            <router-link to="/">{{ $t('nav.home') }}</router-link>
            <div
              class="nav-item about-wrapper"
              :class="{ open: aboutOpen, 'recently-closed': aboutRecentlyClosed }"
              @mouseenter="ensureMembers"
              @focusin="ensureMembers"
            >
              <router-link
                to="/page/about"
                class="about-link"
                @click="handleAboutClick"
                :aria-expanded="aboutOpen ? 'true' : 'false'"
                aria-haspopup="true"
                >{{ $t('nav.about') }}</router-link
              >
              <div class="about-dropdown" v-if="members.length">
                <router-link
                  v-for="m in members"
                  :key="m.id"
                  :to="'/member/' + m.slug"
                  class="about-member"
                  @click="closeNavAfterMember"
                >
                  {{ locale === 'el' ? m.name : m.translations?.en?.name || m.name }}
                </router-link>
              </div>
            </div>
            <router-link to="/albums">{{ $t('nav.albums') }}</router-link>
            <router-link to="/page/appearances">{{ $t('nav.appearances') }}</router-link>
            <div
              class="nav-item gallery-wrapper"
              :class="{ open: galleryOpen, 'recently-closed': galleryRecentlyClosed }"
              @mouseenter="ensureGallery"
              @focusin="ensureGallery"
            >
              <router-link
                to="/gallery"
                class="gallery-link"
                @click="handleGalleryClick"
                :aria-expanded="galleryOpen ? 'true' : 'false'"
                aria-haspopup="true"
                >{{ $t('nav.gallery') }}</router-link
              >
              <div class="gallery-dropdown" v-if="galleryCategories.length">
                <router-link class="gallery-all" to="/gallery" @click="closeNavAfterGallery">{{
                  $t('gallery.all')
                }}</router-link>
                <div
                  v-for="category in galleryCategories"
                  :key="category.key"
                  class="gallery-category"
                >
                  <router-link
                    class="gallery-category-link"
                    :to="{ path: '/gallery', query: { category: category.key } }"
                    @click="closeNavAfterGallery"
                  >
                    {{ displayGalleryCategory(category) }}
                  </router-link>
                </div>
              </div>
            </div>
            <router-link to="/contact">{{ $t('nav.contact') }}</router-link>
            <!-- Custom header pages -->
            <router-link
              v-for="page in customHeaderPages"
              :key="'header-' + page.id"
              :to="'/page/' + page.slug"
              class="custom-page-link"
              @mouseenter="ensureCustomPages"
            >
              {{ displayPageTitle(page) }}
            </router-link>
            <router-link v-if="authed" to="/admin/pages" class="admin-link">{{
              $t('nav.admin')
            }}</router-link>
            <LanguageSwitcher />
          </nav>
        </div>
      </header>
    </div>
    <main class="page-main">
      <router-view />
    </main>
    <footer class="site-footer">
      <div class="inner">
        <div class="footer-grid">
          <!-- About Section with Logos -->
          <div class="footer-column footer-logos-column">
            <router-link to="/" class="footer-logo-link" aria-label="Chorostalites Home">
              <img
                src="/logo-choro.png"
                alt="Chorostalites Logo"
                class="footer-logo footer-logo-main"
                width="150"
                height="29"
                loading="lazy"
              />
            </router-link>
            <router-link to="/page/studio" class="footer-logo-link" aria-label="Studio">
              <img
                src="/logo-studio-white.png"
                alt="Studio Logo"
                class="footer-logo footer-logo-studio"
                width="80"
                height="57"
                loading="lazy"
              />
            </router-link>
            <p class="footer-description">
              {{ $t('footer.description') }}
            </p>
          </div>

          <div class="footer-divider"></div>

          <!-- Quick Links Section -->
          <div class="footer-column">
            <h3 class="footer-heading">{{ $t('footer.quickLinks') }}</h3>
            <nav class="footer-nav">
              <router-link to="/" class="footer-link">{{ $t('nav.home') }}</router-link>
              <router-link to="/members" class="footer-link">{{ $t('nav.members') }}</router-link>
              <router-link to="/discography" class="footer-link">{{
                $t('nav.discography')
              }}</router-link>
              <router-link to="/appearances" class="footer-link">{{
                $t('nav.appearances')
              }}</router-link>
              <router-link to="/gallery" class="footer-link">{{ $t('nav.gallery') }}</router-link>
              <!-- Custom footer pages -->
              <router-link
                v-for="page in customFooterPages"
                :key="'footer-' + page.id"
                :to="'/page/' + page.slug"
                class="footer-link custom-footer-page"
                @mouseenter="ensureCustomPages"
              >
                {{ displayPageTitle(page) }}
              </router-link>
              <router-link to="/contact" class="footer-link">{{ $t('nav.contact') }}</router-link>
            </nav>
          </div>

          <div class="footer-divider"></div>

          <!-- Connect Section -->
          <div class="footer-column">
            <h3 class="footer-heading">{{ $t('footer.connect') }}</h3>

            <!-- Contact Info -->
            <div class="footer-contact-info">
              <a
                v-if="settings.address"
                href="/contact"
                class="footer-contact-item"
                :aria-label="$t('common.address')"
              >
                <svg
                  class="contact-icon"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                >
                  <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
                  <circle cx="12" cy="10" r="3" />
                </svg>
                <span>{{ settings.address }}</span>
              </a>
              <a
                v-if="settings.phone"
                :href="'tel:' + settings.phone.replace(/[^+\\d]/g, '')"
                class="footer-contact-item"
                :aria-label="$t('common.callPhone')"
              >
                <svg
                  class="contact-icon"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                >
                  <path
                    d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 014.11 2h3a2 2 0 012 1.72 12.84 12.84 0 00.7 2.81 2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45 12.84 12.84 0 002.81.7A2 2 0 0122 16.92z"
                  />
                </svg>
                <span>{{ settings.phone }}</span>
              </a>
              <a
                v-if="settings.email1"
                :href="'mailto:' + settings.email1"
                class="footer-contact-item"
                :aria-label="$t('common.emailPrimaryLabel')"
              >
                <svg
                  class="contact-icon"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                >
                  <path
                    d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"
                  />
                  <polyline points="22,6 12,13 2,6" />
                </svg>
                <span>{{ settings.email1 }}</span>
              </a>
              <a
                v-if="settings.email2"
                :href="'mailto:' + settings.email2"
                class="footer-contact-item"
                :aria-label="$t('common.emailSecondaryLabel')"
              >
                <svg
                  class="contact-icon"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                >
                  <path
                    d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"
                  />
                  <polyline points="22,6 12,13 2,6" />
                </svg>
                <span>{{ settings.email2 }}</span>
              </a>
            </div>

            <!-- Social Media -->
            <div class="footer-socials-section" v-if="anySocial">
              <div class="socials footer-socials">
                <a
                  v-if="settings.facebook"
                  :href="settings.facebook"
                  target="_blank"
                  :aria-label="$t('social.facebook')"
                  ><svg viewBox="0 0 24 24">
                    <path
                      d="M13.5 22v-8.25H16l.375-3h-2.875V8.75c0-.87.286-1.5 1.55-1.5H16.5V4.6c-.268-.036-1.188-.1-2.262-.1-2.24 0-3.738 1.37-3.738 3.882V10.75H8v3h2.5V22h3z"
                      fill="currentColor"
                    /></svg
                ></a>
                <a
                  v-if="settings.youtube"
                  :href="settings.youtube"
                  target="_blank"
                  :aria-label="$t('social.youtube')"
                  ><svg viewBox="0 0 24 24">
                    <path
                      fill="currentColor"
                      d="M23 7.1s-.2-1.6-.8-2.3c-.7-.8-1.5-.8-1.9-.9C17.9 3.6 12 3.6 12 3.6h0s-5.9 0-8.3.3c-.4 0-1.2.1-1.9.9C1.2 5.5 1 7.1 1 7.1S.8 8.9.8 10.7v1.6c0 1.8.2 3.6.2 3.6s.2 1.6.8 2.3c.7.8 1.7.8 2.1.9 1.5.1 6.1.3 8.1.3 0 0 5.9 0 8.3-.3.4-.1 1.2-.1 1.9-.9.6-.7.8-2.3.8-2.3s.2-1.8.2-3.6v-1.6c0-1.8-.2-3.6-.2-3.6ZM9.9 14.6V8.4l5.4 3.1-5.4 3.1Z"
                    /></svg
                ></a>
                <a
                  v-if="settings.instagram"
                  :href="settings.instagram"
                  target="_blank"
                  :aria-label="$t('social.instagram')"
                  ><svg viewBox="0 0 24 24">
                    <path
                      fill="currentColor"
                      d="M7 2C4.2 2 2 4.2 2 7v10c0 2.8 2.2 5 5 5h10c2.8 0 5-2.2 5-5V7c0-2.8-2.2-5-5-5H7zm10 2c1.7 0 3 1.3 3 3v10c0 1.7-1.3 3-3 3H7c-1.7 0-3-1.3-3-3V7c0-1.7 1.3-3 3-3h10zm-5 2.5A5.5 5.5 0 006.5 12 5.5 5.5 0 0012 17.5 5.5 5.5 0 0017.5 12 5.5 5.5 0 0012 6.5zm0 2A3.5 3.5 0 0115.5 12 3.5 3.5 0 0112 15.5 3.5 3.5 0 018.5 12 3.5 3.5 0 0112 8.5zM17.8 6a1.3 1.3 0 100 2.6 1.3 1.3 0 000-2.6z"
                    /></svg
                ></a>
                <a
                  v-if="settings.soundcloud"
                  :href="settings.soundcloud"
                  target="_blank"
                  :aria-label="$t('social.soundcloud')"
                  ><svg viewBox="0 0 24 24">
                    <path
                      fill="currentColor"
                      d="M17.6 10.2c-.3 0-.6 0-.9.1a4.6 4.6 0 00-9.1.9v.2a2.55 2.55 0 00.4 5.1h9.6a3.4 3.4 0 00.1-6.8z"
                    /></svg
                ></a>
                <a
                  v-if="settings.spotify"
                  :href="settings.spotify"
                  target="_blank"
                  :aria-label="$t('social.spotify')"
                  ><svg viewBox="0 0 24 24">
                    <path
                      fill="currentColor"
                      d="M12 2.1A9.9 9.9 0 1 0 22 12 9.9 9.9 0 0 0 12 2.1Zm4.55 14.37c-.18.29-.56.38-.85.2-2.34-1.42-5.28-1.74-8.75-.96a.63.63 0 0 1-.3-1.23c3.78-.86 7.02-.5 9.62 1.1.29.18.38.56.2.85Zm1.17-2.62c-.22.35-.69.46-1.04.24-2.67-1.64-6.74-2.12-9.9-1.17a.74.74 0 1 1-.42-1.42c3.6-1.06 8.07-.54 11.14 1.32.35.21.46.68.23 1.03Zm.1-2.78c-3.18-1.89-8.45-2.06-11.5-1.14a.84.84 0 0 1-.47-1.6c3.5-1.03 9.32-.83 12.98 1.36a.85.85 0 0 1-.87 1.46Z"
                    /></svg
                ></a>
                <a
                  v-if="settings.apple"
                  :href="settings.apple"
                  target="_blank"
                  :aria-label="$t('social.apple')"
                  class="apple-link"
                  ><svg viewBox="0 0 24 24" class="apple-icon" aria-hidden="true">
                    <path
                      fill="currentColor"
                      d="M12 3v10.55c-.59-.34-1.27-.55-2-.55-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4V7h4V3h-6z"
                    /></svg
                ></a>
              </div>
            </div>
          </div>
        </div>

        <!-- Version Info (Admin pages only) -->
        <div class="footer-version" v-if="appVersion && isAdminPage">
          <span class="version-label">v{{ appVersion }}</span>
        </div>
      </div>
    </footer>
  </div>
</template>

<script setup>
import { ref, watch, onMounted, computed, onBeforeUnmount } from 'vue'
import { isAuthed } from './api'
import { useRoute, useRouter } from 'vue-router'
import { api } from './api'
import { useI18n } from 'vue-i18n'
import LanguageSwitcher from './components/LanguageSwitcher.vue'

const mobileNav = ref(false)
// Mobile only controlled open state for About submenu
const aboutOpen = ref(false)
// Mobile only controlled open state for Gallery submenu
const galleryOpen = ref(false)
const authed = ref(false) // Initialize to false, will be set by checkAuth
const router = useRouter()
const route = useRoute()
const members = ref([])
const gallerySections = ref([])
const customHeaderPages = ref([])
const customFooterPages = ref([])
// Prevent immediate hover reopen after selecting a member on desktop
const aboutRecentlyClosed = ref(false)
const galleryRecentlyClosed = ref(false)
const membersLoaded = ref(false)
const galleryLoaded = ref(false)
const customPagesLoaded = ref(false)
const { locale, t } = useI18n()
const settings = ref({})
const appVersion = ref('')

const DEFAULT_PRIMARY = '#363535'
const DEFAULT_SECONDARY = '#262222'

function normalizeHexColor(value, fallback) {
  if (!value || typeof value !== 'string') return fallback
  const trimmed = value.trim()
  if (!/^#([0-9a-fA-F]{3}){1,2}$/.test(trimmed)) return fallback
  if (trimmed.length === 4) {
    const [r, g, b] = trimmed.slice(1).split('')
    return `#${r}${r}${g}${g}${b}${b}`.toLowerCase()
  }
  return trimmed.toLowerCase()
}

function hexToRgbTuple(hex) {
  const normalized = normalizeHexColor(hex, '')
  if (!normalized) return null
  const value = normalized.slice(1)
  const r = parseInt(value.slice(0, 2), 16)
  const g = parseInt(value.slice(2, 4), 16)
  const b = parseInt(value.slice(4, 6), 16)
  return [r, g, b]
}

function applyThemeFromSettings(nextSettings) {
  if (typeof document === 'undefined') return
  const primary = normalizeHexColor(nextSettings?.primary_color, DEFAULT_PRIMARY)
  const secondary = normalizeHexColor(nextSettings?.secondary_color, DEFAULT_SECONDARY)
  const root = document.documentElement
  root.style.setProperty('--primary', primary)
  root.style.setProperty('--secondary', secondary)
  root.style.setProperty('--outer', primary)
  root.style.setProperty('--inner', secondary)
  const primaryRgb = hexToRgbTuple(primary)
  const secondaryRgb = hexToRgbTuple(secondary)
  if (primaryRgb) root.style.setProperty('--outer-rgb', primaryRgb.join(', '))
  if (secondaryRgb) root.style.setProperty('--inner-rgb', secondaryRgb.join(', '))
}

const GALLERY_CATEGORIES = [
  { key: 'moments', labelKey: 'gallery.personalMoments' },
  { key: 'videoclips', labelKey: 'gallery.videoclips' },
  { key: 'interviews', labelKey: 'gallery.interviews' }
]
const GALLERY_CATEGORY_KEYS = new Set(GALLERY_CATEGORIES.map((cat) => cat.key))

function normalizeGalleryCategory(value) {
  return GALLERY_CATEGORY_KEYS.has(value) ? value : 'moments'
}

function displayGalleryCategory(category) {
  if (!category) return ''
  const found = GALLERY_CATEGORIES.find((item) => item.key === category.key)
  return found ? t(found.labelKey) : category.key
}

function displayGallerySection(section) {
  if (!section) return ''
  if (locale.value === 'el') return section.title
  return section.translations?.en?.title || section.title
}

const galleryCategories = computed(() => {
  return GALLERY_CATEGORIES.map((category) => {
    const sections = gallerySections.value
      .filter((section) => normalizeGalleryCategory(section.category) === category.key)
      .sort((a, b) => (a.order || 0) - (b.order || 0) || a.id - b.id)
    return { key: category.key, sections }
  })
})

async function ensureMembers() {
  if (membersLoaded.value) return
  try {
    const { data } = await api.get('/members')
    members.value = data
  } catch {
    /* ignore */
  } finally {
    membersLoaded.value = true
  }
}

async function ensureGallery() {
  if (galleryLoaded.value) return
  try {
    const { data } = await api.get('/gallery/sections')
    gallerySections.value = data
  } catch {
    /* ignore */
  } finally {
    galleryLoaded.value = true
  }
}

async function ensureCustomPages() {
  if (customPagesLoaded.value) return
  try {
    const { data } = await api.get('/pages')
    // Filter for custom pages that should be shown in menus
    const customPages = data.filter((p) => !p.is_default && p.show_in_menu)
    customHeaderPages.value = customPages
      .filter((p) => p.menu_position === 'header')
      .sort((a, b) => (a.menu_order || 0) - (b.menu_order || 0))
    customFooterPages.value = customPages
      .filter((p) => p.menu_position === 'footer')
      .sort((a, b) => (a.menu_order || 0) - (b.menu_order || 0))
  } catch {
    /* ignore */
  } finally {
    customPagesLoaded.value = true
  }
}

function displayPageTitle(page) {
  if (!page) return ''
  if (locale.value === 'el') return page.title
  return page.translations?.en?.title || page.title
}

watch(route, () => {
  mobileNav.value = false
  aboutOpen.value = false
  galleryOpen.value = false
})

async function loadSettings() {
  try {
    const { data } = await api.get('/settings')
    settings.value = data
    applyThemeFromSettings(settings.value)
  } catch {
    /* ignore */
  }
}

function applyPreview(e) {
  if (e?.detail) {
    settings.value = { ...settings.value, ...e.detail }
    applyThemeFromSettings(settings.value)
  }
}

function refreshAfterSave() {
  loadSettings()
}

const anySocial = computed(() =>
  ['facebook', 'youtube', 'instagram', 'soundcloud', 'spotify', 'apple'].some(
    (k) => settings.value[k]
  )
)

// Show bar whenever explicitly enabled, even if currently empty (allows admin to see placement before filling data)
const hasTopBar = computed(() => settings.value.show_top_bar !== '0')

// Show version badge only on admin pages
const isAdminPage = computed(() => route.path.startsWith('/admin'))

function isMobile() {
  if (typeof window === 'undefined') return false
  return window.matchMedia('(max-width: 860px)').matches
}

function handleAboutClick(e) {
  if (!isMobile()) {
    aboutOpen.value = false
    return
  }
  ensureMembers()
  if (!aboutOpen.value) {
    e.preventDefault()
    aboutOpen.value = true
    return
  }
  e.preventDefault()
  aboutOpen.value = false
  router.push('/page/about')
}

function handleGalleryClick(e) {
  if (!isMobile()) {
    galleryOpen.value = false
    return
  }
  ensureGallery()
  if (!galleryOpen.value) {
    e.preventDefault()
    galleryOpen.value = true
    return
  }
  e.preventDefault()
  galleryOpen.value = false
  router.push('/gallery')
}

function closeNavAfterMember() {
  mobileNav.value = false
  aboutOpen.value = false
  if (!isMobile()) {
    aboutRecentlyClosed.value = true
    setTimeout(() => {
      aboutRecentlyClosed.value = false
    }, 600)
  }
}

function closeNavAfterGallery() {
  mobileNav.value = false
  galleryOpen.value = false
  if (!isMobile()) {
    galleryRecentlyClosed.value = true
    setTimeout(() => {
      galleryRecentlyClosed.value = false
    }, 600)
  }
}

async function checkAuth() {
  authed.value = await isAuthed()
}

async function fetchVersion() {
  try {
    const { data } = await api.get('/version')
    appVersion.value = data.version || ''
  } catch {
    // Silently fail - version is optional
    appVersion.value = ''
  }
}

function handleLogout() {
  authed.value = false
}

onMounted(async () => {
  // Only check auth on admin routes (not for regular visitors)
  const isAdminRoute = window.location.pathname.startsWith('/admin/')
  if (isAdminRoute) {
    await checkAuth()
  }
  loadSettings()
  ensureCustomPages()
  fetchVersion()
  window.addEventListener('settings-preview', applyPreview)
  window.addEventListener('settings-updated', refreshAfterSave)
  window.addEventListener('auth-logout', handleLogout)
})

onBeforeUnmount(() => {
  window.removeEventListener('settings-preview', applyPreview)
  window.removeEventListener('settings-updated', refreshAfterSave)
  window.removeEventListener('auth-logout', handleLogout)
})
</script>

<style>
:root {
  --primary: #363535;
  --secondary: #262222;
  --outer: #363535;
  --outer-rgb: 54, 53, 53;
  --inner: #262222;
  --inner-rgb: 38, 34, 34;
  --bg: var(--outer);
  --bg-alt: var(--inner);
  --text: #eee;
  --accent: rgb(224, 126, 39);
  --accent-rgb: 224, 126, 39;
  --radius: 8px;
  --container: 1180px;
  --ease: cubic-bezier(0.4, 0, 0.2, 1);
  --border: rgba(0, 0, 0, 0.35);
  --border-strong: rgba(0, 0, 0, 0.5);
  --font: 'Inter', system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif;
}

html,
body {
  height: 100%;
  margin: 0;
  padding: 0;
  overflow-x: hidden;
}
#app {
  min-height: 100%;
  display: flex;
  flex-direction: column;
}
body {
  margin: 0;
  background: var(--bg);
  color: var(--text);
  font-family: var(--font);
  -webkit-font-smoothing: antialiased;
  overflow-x: hidden;
}
a {
  color: var(--accent);
  text-decoration: none;
}
a:hover {
  text-decoration: underline;
}
h1,
h2,
h3,
h4 {
  font-weight: 600;
  line-height: 1.15;
  letter-spacing: 0.5px;
}
p {
  line-height: 1.6;
}

.page-loading {
  width: 36px;
  height: 36px;
  margin: 1.25rem auto;
  border-radius: 999px;
  border: 3px solid rgba(var(--accent-rgb), 0.25);
  border-top-color: var(--accent);
  animation: page-spinner 0.8s linear infinite;
}

@keyframes page-spinner {
  to {
    transform: rotate(360deg);
  }
}

/* Global scrollbar + box sizing */
::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}
::-webkit-scrollbar-track {
  background: var(--inner);
}
::-webkit-scrollbar-thumb {
  background: rgba(224, 126, 39, 0.5);
  border: 2px solid var(--inner);
  border-radius: 30px;
}
::-webkit-scrollbar-thumb:hover {
  background: rgb(224, 126, 39);
}
* {
  scrollbar-width: thin;
  scrollbar-color: rgba(224, 126, 39, 0.5) var(--inner);
  box-sizing: border-box;
}

img {
  max-width: 100%;
  display: block;
}

.app-shell {
  min-height: 100vh;
  min-height: 100dvh;
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 100vw;
  overflow-x: hidden;
  position: relative;
}
.site-chrome {
  position: sticky;
  top: 0;
  z-index: 60;
  width: 100%;
}
.site-header {
  backdrop-filter: saturate(180%) blur(12px);
  background: rgba(var(--inner-rgb), 0.85);
  border-bottom: 1px solid var(--border);
  width: 100%;
  position: relative;
}
.global-topbar {
  background: var(--inner);
  border-bottom: 1px solid var(--border);
  font-size: 0.6rem;
  letter-spacing: 0.5px;
  color: #aaa;
  position: relative;
  z-index: 60;
  min-height: 28px;
}
.global-topbar .bar-inner {
  max-width: var(--container);
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.35rem 1.05rem;
  gap: 1rem;
  flex-wrap: wrap;
}
.socials {
  display: flex;
  gap: 0.35rem;
  flex-wrap: wrap;
}
.socials a {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  display: grid;
  place-items: center;
  background: var(--inner);
  border: 1px solid var(--border);
  color: #ddd;
  font-size: 0.6rem;
  text-decoration: none;
  transition: 0.3s var(--ease);
}
.socials a:hover {
  background: var(--accent);
  color: #000;
  border-color: var(--accent);
}
.socials a svg {
  width: 18px;
  height: 18px;
  display: block;
}
.socials a.apple-link {
  font-size: 0;
}
/* Apple Music icon sizing */
.socials a.apple-link .apple-icon {
  width: 18px;
  height: 18px;
}
.contacts {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
}
.contacts span {
  white-space: nowrap;
  opacity: 0.85;
}
.contacts .contact-link {
  white-space: nowrap;
  opacity: 1;
  color: #ffffff;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  font-size: 0.7rem;
}
.contacts .contact-link:hover {
  text-decoration: underline;
  opacity: 1;
}
.site-header .inner {
  max-width: var(--container);
  margin: 0 auto;
  display: flex;
  align-items: center;
  gap: 2rem;
  padding: 0.75rem 1.25rem;
  position: relative;
}
.logo {
  font-weight: 700;
  font-size: 1.1rem;
  letter-spacing: 1px;
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  text-decoration: none;
  color: var(--text);
  position: relative;
}
.logo-image {
  height: auto;
  max-height: 38px;
  width: auto;
  max-width: 160px;
  object-fit: contain;
  display: block;
  flex-shrink: 0;
}
.logo.has-logo-image .logo-text {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
}
.nav-toggle {
  display: none;
  background: none;
  border: 1px solid var(--border-strong);
  color: var(--text);
  padding: 0.4rem 0.65rem;
  font-size: 1.1rem;
  border-radius: 6px;
  cursor: pointer;
}
.main-nav {
  display: flex;
  gap: 1.25rem;
  align-items: center;
  margin-left: auto;
}
.main-nav a {
  position: relative;
  font-size: 0.95rem;
  font-weight: 500;
  padding: 0.35rem 0;
}
.main-nav a.router-link-active {
  color: var(--accent);
}
.main-nav a.router-link-active::after {
  content: '';
  position: absolute;
  left: 0;
  right: 0;
  bottom: -4px;
  height: 2px;
  background: linear-gradient(90deg, var(--accent), rgba(var(--accent-rgb), 0));
  border-radius: 2px;
}
.main-nav a.custom-page-link {
  opacity: 0.9;
}
.main-nav a.custom-page-link:hover {
  opacity: 1;
}
.nav-item {
  position: relative;
}
.about-wrapper {
  display: flex;
  flex-direction: column;
}
.about-wrapper > .about-link {
  display: inline-flex;
  align-items: center;
  position: relative;
}
.about-wrapper > .about-link::after {
  content: '\25BE';
  font-size: 0.7rem;
  margin-left: 0.4rem;
  line-height: 1;
  opacity: 0.55;
  transform: translateY(0) rotate(0deg);
  transition: 0.35s var(--ease);
  color: currentColor;
}
.about-wrapper:hover > .about-link::after,
.about-wrapper:focus-within > .about-link::after {
  opacity: 1;
  transform: translateY(2px) rotate(0deg);
}
.about-dropdown {
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translate(-50%, 8px);
  min-width: 240px;
  background: var(--inner);
  border: 1px solid var(--border);
  border-radius: 12px;
  padding: 0.8rem 0.9rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  opacity: 0;
  pointer-events: none;
  transition:
    opacity 0.35s var(--ease),
    transform 0.35s var(--ease);
  box-shadow: 0 16px 40px -12px rgba(0, 0, 0, 0.65);
  z-index: 60;
  will-change: opacity, transform;
  backface-visibility: hidden;
}
.about-wrapper:hover .about-dropdown,
.about-wrapper:focus-within .about-dropdown {
  opacity: 1;
  transform: translate(-50%, 0);
  pointer-events: auto;
}
.about-wrapper.recently-closed .about-dropdown {
  opacity: 0 !important;
  pointer-events: none !important;
}
.about-member {
  font-size: 0.8rem;
  font-weight: 500;
  letter-spacing: 0.3px;
  padding: 0.5rem 0.7rem 0.5rem 0.9rem;
  border-radius: 8px;
  position: relative;
  color: #ddd;
  text-decoration: none;
  background: rgba(0, 0, 0, 0.2);
  border: 1px solid var(--border);
  transition: all 0.25s var(--ease);
}
.about-member:hover {
  background: var(--accent);
  color: #000;
  border-color: var(--accent);
  text-decoration: none;
  transform: translateY(-2px);
  box-shadow: 0 6px 16px -6px rgba(224, 126, 39, 0.4);
}
.about-dropdown::before {
  content: '';
  position: absolute;
  top: -7px;
  left: 50%;
  width: 14px;
  height: 14px;
  background: var(--inner);
  border: 1px solid var(--border);
  border-bottom: none;
  border-right: none;
  transform: translate(-50%, 0) rotate(45deg);
}

.gallery-wrapper {
  position: relative;
  display: flex;
  flex-direction: column;
}
.gallery-wrapper > .gallery-link {
  display: inline-flex;
  align-items: center;
  position: relative;
}
.gallery-wrapper > .gallery-link::after {
  content: '\25BE';
  font-size: 0.7rem;
  margin-left: 0.4rem;
  line-height: 1;
  opacity: 0.55;
  transform: translateY(0) rotate(0deg);
  transition: 0.35s var(--ease);
  color: currentColor;
}
.gallery-wrapper:hover > .gallery-link::after,
.gallery-wrapper:focus-within > .gallery-link::after {
  opacity: 1;
  transform: translateY(2px) rotate(0deg);
}
.gallery-dropdown {
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translate(-50%, 8px);
  min-width: 280px;
  max-width: 380px;
  background: var(--inner);
  border: 1px solid var(--border);
  border-radius: 12px;
  padding: 0.8rem 0.9rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  opacity: 0;
  pointer-events: none;
  transition:
    opacity 0.35s var(--ease),
    transform 0.35s var(--ease);
  box-shadow: 0 16px 40px -12px rgba(0, 0, 0, 0.65);
  z-index: 60;
  will-change: opacity, transform;
  backface-visibility: hidden;
}
.gallery-wrapper:hover .gallery-dropdown,
.gallery-wrapper:focus-within .gallery-dropdown {
  opacity: 1;
  transform: translate(-50%, 0);
  pointer-events: auto;
}
.gallery-wrapper.recently-closed .gallery-dropdown {
  opacity: 0 !important;
  pointer-events: none !important;
}
.gallery-all {
  font-size: 0.8rem;
  letter-spacing: 0.3px;
  font-weight: 500;
  color: #ddd;
  text-decoration: none;
  padding: 0.5rem 0.7rem 0.5rem 0.9rem;
  border-radius: 8px;
  background: rgba(0, 0, 0, 0.2);
  border: 1px solid var(--border);
  transition: all 0.25s var(--ease);
}
.gallery-all:hover {
  background: var(--accent);
  color: #000;
  border-color: var(--accent);
  text-decoration: none;
  transform: translateY(-2px);
  box-shadow: 0 6px 16px -6px rgba(224, 126, 39, 0.4);
}

/* Override active styles for dropdown items to match default style */
.main-nav .about-member.router-link-active,
.main-nav .gallery-all.router-link-active {
  color: #ddd;
}
.main-nav .about-member.router-link-active:hover,
.main-nav .gallery-all.router-link-active:hover {
  color: #000;
}
.main-nav .about-member.router-link-active::after,
.main-nav .gallery-all.router-link-active::after {
  display: none;
}

.gallery-category {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
}
.gallery-category-link {
  font-size: 0.75rem;
  letter-spacing: 1px;
  font-weight: 500;
  color: #ddd;
  text-decoration: none;
  padding: 0.5rem 0.7rem 0.5rem 0.9rem;
  border-radius: 8px;
  background: rgba(0, 0, 0, 0.2);
  border: 1px solid var(--border);
  transition: all 0.25s var(--ease);
  display: block;
}
.gallery-category-link:hover {
  background: var(--accent);
  color: #000;
  border-color: var(--accent);
  text-decoration: none;
  transform: translateY(-2px);
  box-shadow: 0 6px 16px -6px rgba(224, 126, 39, 0.4);
}
.gallery-subsections {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
}
.gallery-section-link {
  font-size: 0.78rem;
  font-weight: 500;
  color: #ddd;
  text-decoration: none;
  padding: 0.5rem 0.7rem 0.5rem 0.9rem;
  border-radius: 8px;
  border: 1px solid var(--border);
  background: rgba(0, 0, 0, 0.2);
  transition: all 0.25s var(--ease);
}
.gallery-section-link:hover {
  background: var(--accent);
  color: #000;
  border-color: var(--accent);
  text-decoration: none;
  transform: translateY(-2px);
  box-shadow: 0 6px 16px -6px rgba(224, 126, 39, 0.4);
}

@media (max-width: 860px) {
  .about-wrapper {
    width: 100%;
  }
  .about-wrapper > .about-link::after {
    display: none;
  }
  .about-dropdown {
    position: static;
    opacity: 0;
    transform: none !important;
    pointer-events: none;
    background: transparent;
    border: none;
    padding: 0;
    box-shadow: none;
    gap: 0.2rem;
    max-height: 0;
    overflow: hidden;
    transition:
      opacity 0.3s var(--ease),
      max-height 0.4s var(--ease);
  }
  .about-wrapper.open .about-dropdown {
    opacity: 1;
    pointer-events: auto;
    max-height: 500px;
    padding: 0.25rem 0 0;
  }
  .about-dropdown::before {
    display: none;
  }
  .about-member {
    background: var(--inner);
    border: 1px solid var(--border);
  }
  .about-member:hover {
    background: var(--inner);
    transform: none;
  }
  .gallery-wrapper {
    width: 100%;
  }
  .gallery-wrapper > .gallery-link::after {
    display: none;
  }
  .gallery-dropdown {
    position: static;
    opacity: 0;
    transform: none !important;
    pointer-events: none;
    background: transparent;
    border: none;
    padding: 0;
    box-shadow: none;
    gap: 0.35rem;
    max-height: 0;
    overflow: hidden;
    transition:
      opacity 0.3s var(--ease),
      max-height 0.4s var(--ease);
  }
  .gallery-wrapper.open .gallery-dropdown {
    opacity: 1;
    pointer-events: auto;
    max-height: 600px;
    padding: 0.25rem 0 0;
  }
  .gallery-all,
  .gallery-category-link,
  .gallery-section-link {
    background: var(--inner);
    border: 1px solid var(--border);
    color: #eee;
    text-decoration: none;
    border-radius: 10px;
  }
  .gallery-all {
    margin: 0 0 0.3rem;
  }
  .gallery-category {
    gap: 0.3rem;
  }
  .gallery-category-link {
    padding: 0.6rem 0.85rem;
    font-size: clamp(0.8rem, 3.2vw, 0.9rem);
  }
  .gallery-section-link {
    padding: 0.55rem 0.85rem;
    margin-left: 0.5rem;
    max-width: calc(92% - 0.5rem);
  }
  .gallery-section-link:hover {
    background: var(--inner);
    color: #eee;
    border-color: var(--border);
  }

  /* Topbar mobile improvements */
  .global-topbar .bar-inner {
    justify-content: center;
    text-align: center;
    padding: 0.5rem;
  }

  .socials {
    justify-content: center;
    margin-bottom: 0.4rem;
  }

  .contacts {
    justify-content: center;
    width: 100%;
  }
}
.admin-link {
  margin-left: 1rem;
  font-size: 0.8rem;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  border: 1px solid var(--border-strong);
  padding: 0.3rem 0.6rem;
  border-radius: 40px;
}
.admin-link:hover {
  background: var(--inner);
  text-decoration: none;
}

@media (max-width: 860px) {
  .site-header .inner {
    justify-content: space-between;
    padding: 0.65rem 0.9rem;
  }
  .logo {
    font-size: 1rem;
    letter-spacing: 0.8px;
  }
  .logo-image {
    max-height: 44px;
    max-width: 220px;
  }
  .nav-toggle {
    display: inline-block;
    margin-left: auto;
    z-index: 80;
  }
  .main-nav {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    background: rgba(var(--inner-rgb), 0.98);
    backdrop-filter: blur(10px);
    border-bottom: 1px solid var(--border);
    display: flex;
    flex-direction: column;
    padding: 0 0.9rem 0.9rem;
    gap: 0.15rem;
    max-height: 0;
    overflow: hidden;
    transform-origin: top center;
    transform: scaleY(0.8);
    opacity: 0;
    transition:
      max-height 0.5s var(--ease),
      opacity 0.35s var(--ease),
      transform 0.45s var(--ease);
  }
  .app-shell.nav-open .main-nav {
    max-height: 70dvh;
    opacity: 1;
    transform: scaleY(1);
    overflow: auto;
  }
  .main-nav a,
  .main-nav .about-link,
  .main-nav .about-member {
    font-size: clamp(0.9rem, 3.4vw, 1rem);
    padding: 0.65rem 0.85rem;
    width: auto;
    min-width: 60%;
    max-width: 92%;
    display: block;
    border-radius: 10px;
    color: #eee;
    background: var(--inner);
    margin: 0.15rem auto 0;
    line-height: 1.2;
    position: relative;
    text-decoration: none;
    box-shadow: 0 2px 4px -2px rgba(0, 0, 0, 0.4);
  }
  .main-nav a + a,
  .main-nav .about-wrapper + a {
    margin-top: 0.25rem;
  }
  .main-nav .about-wrapper {
    width: 100%;
  }
  .main-nav .about-dropdown {
    padding: 0.25rem 0 0;
    gap: 0.15rem;
  }
  .main-nav .about-member {
    font-size: clamp(0.75rem, 3.2vw, 0.85rem);
    background: var(--inner);
    margin: 0.15rem 0 0 0.5rem;
    max-width: calc(92% - 0.5rem);
  }
  .main-nav a:hover,
  .main-nav .about-link:hover,
  .main-nav .about-member:hover {
    background: var(--inner);
    text-decoration: none;
  }
  .main-nav a.router-link-active,
  .main-nav a.router-link-exact-active {
    background: linear-gradient(145deg, var(--accent), #f5d24a);
    color: #000;
    font-weight: 600;
    box-shadow: 0 4px 10px -4px rgba(0, 0, 0, 0.6);
  }
  .main-nav a.router-link-active::after,
  .main-nav a.router-link-exact-active::after {
    display: none;
  }
  body.nav-open {
    overflow: hidden;
  }
  html,
  body {
    overscroll-behavior: contain;
  }
}

@media (max-width: 480px) {
  .main-nav {
    padding: 0 0.6rem 0.75rem;
  }
  .main-nav a,
  .main-nav .about-link,
  .main-nav .about-member {
    max-width: 94%;
  }
  .logo {
    font-size: 0.9rem;
    white-space: nowrap;
  }
  .logo-image {
    max-height: 38px;
    max-width: 190px;
  }
}

.page-main {
  flex: 1 0 auto;
  width: 100%;
}
.site-footer {
  flex-shrink: 0;
  background: var(--bg-alt);
  padding: 1.5rem 1rem;
  margin-top: 3rem;
  border-top: 2px solid var(--accent);
  width: 100%;
}
@media (max-width: 720px) {
  .site-footer {
    padding: 1.25rem 1rem;
    margin-top: 0;
  }
  .page-main {
    padding-bottom: 0;
  }
}
.site-footer .inner {
  max-width: var(--container);
  margin: 0 auto;
  letter-spacing: 0.5px;
  padding: 0.75rem 1.5rem;
}

/* Footer Grid Layout */
.footer-grid {
  display: grid;
  grid-template-columns: 1fr 2px 1fr 2px 1fr;
  gap: 2.5rem;
  align-items: start;
}

.footer-divider {
  width: 2px;
  height: 100%;
  min-height: 150px;
  background: linear-gradient(
    to bottom,
    transparent 0%,
    var(--accent) 15%,
    var(--accent) 85%,
    transparent 100%
  );
  margin: 0;
  align-self: stretch;
}

@media (max-width: 900px) {
  .footer-grid {
    grid-template-columns: 1fr;
    gap: 2rem;
  }
  .footer-divider {
    display: none;
  }
  .footer-column:not(:last-child) {
    padding-bottom: 1.5rem;
    border-bottom: 2px solid var(--accent);
  }
}

@media (max-width: 600px) {
  .footer-grid {
    gap: 1.75rem;
  }
}

.footer-column {
  display: flex;
  flex-direction: column;
  gap: 0.65rem;
}

.footer-logos-column {
  gap: 1rem;
}

.footer-logo-link {
  display: block;
  width: fit-content;
  transition:
    opacity 0.2s ease,
    transform 0.2s ease;
}

.footer-logo-link:hover {
  opacity: 0.85;
  transform: translateY(-2px);
}

.footer-logo {
  display: block;
  height: auto;
  object-fit: contain;
}

.footer-logo-main {
  max-width: 220px;
  width: 100%;
}

.footer-logo-studio {
  max-width: 110px;
  width: 100%;
}

@media (max-width: 900px) {
  .footer-logo-main {
    max-width: 180px;
  }

  .footer-logo-studio {
    max-width: 95px;
  }
}

@media (max-width: 600px) {
  .footer-logo-main {
    max-width: 150px;
  }

  .footer-logo-studio {
    max-width: 80px;
  }
}

@media (max-width: 400px) {
  .footer-logos-column {
    align-items: center;
    text-align: center;
  }

  .footer-logo-main {
    max-width: 130px;
  }

  .footer-logo-studio {
    max-width: 70px;
  }
}

.footer-heading {
  font-size: 0.95rem;
  font-weight: 600;
  margin: 0 0 0.35rem 0;
  color: var(--accent);
  text-transform: uppercase;
  letter-spacing: 1.2px;
}

.footer-description {
  margin: 0;
  font-size: 0.85rem;
  line-height: 1.5;
  opacity: 0.85;
  color: var(--text);
}

/* Footer Navigation */
.footer-nav {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.footer-link {
  color: var(--text);
  text-decoration: none;
  font-size: 0.85rem;
  opacity: 0.85;
  transition: all 0.2s ease;
  display: inline-block;
  width: fit-content;
  position: relative;
}

.footer-link:hover {
  opacity: 1;
  color: var(--accent);
  transform: translateX(4px);
}

.footer-link.custom-footer-page {
  padding-left: 0.65rem;
  font-size: 0.8rem;
}

.footer-link.custom-footer-page::before {
  content: '';
  position: absolute;
  left: 0;
  top: 50%;
  width: 3px;
  height: 3px;
  background: var(--accent);
  border-radius: 50%;
  transform: translateY(-50%);
  opacity: 0.6;
}

.footer-link.custom-footer-page:hover::before {
  opacity: 1;
}

/* Contact Info Section */
.footer-contact-info {
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
  margin-bottom: 0.85rem;
}

.footer-contact-item {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  color: var(--text);
  text-decoration: none;
  font-size: 0.85rem;
  opacity: 0.85;
  transition: all 0.2s ease;
}

.footer-contact-item:hover {
  opacity: 1;
  color: var(--accent);
}

.contact-icon {
  width: 17px;
  height: 17px;
  flex-shrink: 0;
  opacity: 0.8;
  transition: opacity 0.2s ease;
}

.footer-contact-item:hover .contact-icon {
  opacity: 1;
}

/* Footer Socials Section */
.footer-socials-section {
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
}

.footer-social-label {
  margin: 0;
  font-size: 0.8rem;
  font-weight: 500;
  opacity: 0.9;
  color: var(--text);
}

.footer-socials {
  gap: 0.5rem;
}

.footer-socials-section svg:hover {
  transform: scale(1.1);
  opacity: 1;
}

/* Footer Version */
.footer-version {
  margin-top: 2rem;
  padding-top: 1rem;
  border-top: 1px solid rgba(var(--accent-rgb), 0.3);
  text-align: center;
  font-size: 0.75rem;
  opacity: 0.6;
  color: var(--text);
}

.version-label {
  font-family: 'Courier New', monospace;
  font-weight: 600;
  letter-spacing: 0.5px;
}

@media (max-width: 900px) {
  .footer-version {
    margin-top: 1.5rem;
  }
}

/* Legacy styles cleanup */
.footer-meta {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1.5rem;
  flex-wrap: wrap;
  margin-bottom: 1.2rem;
}
.footer-contacts {
  display: flex;
  flex-wrap: wrap;
  gap: 0.9rem;
  font-size: 0.75rem;
}
.footer-contact {
  color: var(--text);
  text-decoration: none;
  opacity: 0.85;
}
.footer-contact:hover {
  text-decoration: underline;
  opacity: 1;
}

@media (max-width: 720px) {
  .footer-meta {
    align-items: flex-start;
    flex-direction: column;
  }
  .footer-contacts {
    justify-content: flex-start;
  }
}

/* Utilities */
.inner-section {
  max-width: var(--container);
  margin: 0 auto;
  padding: 3.5rem 1.25rem;
}
.grid {
  display: grid;
  gap: 2rem;
}
.grid.cols-2 {
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
}
.card {
  background: linear-gradient(145deg, var(--inner), var(--inner));
  border: 1px solid var(--border);
  border-radius: var(--radius);
  padding: 1.25rem 1.3rem 1.4rem;
  position: relative;
  box-shadow: 0 4px 16px -4px rgba(0, 0, 0, 0.6);
}
.card h3 {
  margin-top: 0;
  font-size: 1.05rem;
}
.badge {
  display: inline-block;
  background: var(--inner);
  padding: 0.25rem 0.6rem;
  border-radius: 30px;
  font-size: 0.65rem;
  letter-spacing: 0.5px;
  text-transform: uppercase;
}
.cta-buttons {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
  margin-top: 1rem;
}
.btn {
  --btn-bg: var(--accent);
  --btn-color: #000;
  border: none;
  background: var(--btn-bg);
  color: var(--btn-color);
  font-weight: 600;
  padding: 0.75rem 1.15rem;
  border-radius: 40px;
  font-size: 0.9rem;
  cursor: pointer;
  letter-spacing: 0.5px;
  display: inline-flex;
  align-items: center;
  gap: 0.55rem;
  position: relative;
  overflow: hidden;
}
.btn.outline {
  background: transparent;
  color: var(--accent);
  border: 1px solid var(--accent);
}
.btn:hover {
  filter: brightness(1.1);
}
.btn:active {
  transform: translateY(2px);
}

/* Hero (used on Home) */
.hero {
  position: relative;
  min-height: 64dvh;
  display: flex;
  align-items: center;
}
.hero .media-bg {
  position: absolute;
  inset: 0;
  background: #000 center/cover no-repeat;
  opacity: 0.45;
}
.hero .overlay {
  position: absolute;
  inset: 0;
  background:
    radial-gradient(circle at 30% 40%, rgba(230, 184, 0, 0.35), transparent 60%),
    linear-gradient(180deg, rgba(0, 0, 0, 0.2), #000);
  mix-blend-mode: overlay;
}
.hero .content {
  position: relative;
  max-width: var(--container);
  margin: 0 auto;
  padding: 5rem 1.25rem 4rem;
}
.hero h1 {
  font-size: clamp(2.2rem, 5vw, 3.4rem);
  margin: 0 0 1rem;
  background: linear-gradient(90deg, #fff, var(--accent));
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
}
.hero p.lead {
  font-size: clamp(1.05rem, 1.6vw, 1.35rem);
  max-width: 60ch;
  color: #ddd;
  margin: 0 0 1.75rem;
}

/* Carousel */
.carousel {
  position: relative;
  overflow: hidden;
  border-radius: var(--radius);
}
.carousel-track {
  display: flex;
  transition: transform 0.7s var(--ease);
}
.carousel-slide {
  min-width: 100%;
  height: 400px;
  position: relative;
  background: #000 center/cover no-repeat;
}
.carousel-slide::after {
  content: '';
  position: absolute;
  inset: 0;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0.1), #000);
  opacity: 0.5;
}
.carousel-controls {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  pointer-events: none;
}
.carousel button {
  pointer-events: auto;
  background: rgba(0, 0, 0, 0.55);
  border: 1px solid var(--border);
  color: #fff;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  cursor: pointer;
  display: grid;
  place-items: center;
  font-size: 1.2rem;
  backdrop-filter: blur(4px);
}
.carousel button:hover {
  background: rgba(224, 126, 39, 0.2);
  color: rgb(224, 126, 39);
}
.dots {
  position: absolute;
  bottom: 12px;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  gap: 0.5rem;
}
.dots button {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  border: none;
  background: rgba(var(--inner-rgb), 0.7);
  cursor: pointer;
  padding: 0;
}
.dots button.active {
  background: var(--accent);
  box-shadow: 0 0 0 3px rgba(var(--accent-rgb), 0.4);
}

/* Page content styling */
main section {
  max-width: var(--container);
  margin: 0 auto;
  padding: 2.5rem 1.25rem;
}
main section:first-child {
  padding-top: 2.5rem;
}
main section:last-child {
  margin-bottom: 0;
  padding-bottom: 2.5rem;
}
main section h2:first-child {
  margin-top: 0;
}

/* Prevent transform/position issues causing misaligned hover states */
main,
.page-main {
  transform: translateZ(0);
  backface-visibility: hidden;
  -webkit-backface-visibility: hidden;
  will-change: auto;
  isolation: isolate;
}

/* Ensure no stray margins create gaps */
.landing,
.landing > *:last-child {
  margin-bottom: 0;
}

/* Smooth fade for route transitions (optional) */
/* (Would need <transition> in router-view wrapper for full effect) */
</style>
